import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

var IconInfoThin = function IconInfoThin(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? '#FFFFFF' : _ref$color,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 20 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 20 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-info-thin ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 20 20'
        },
        React.createElement(
            'g',
            { transform: 'translate(1 1)', fill: 'none', fillRule: 'evenodd' },
            React.createElement('circle', {
                className: 'stroke-color',
                stroke: color,
                cx: '9',
                cy: '9',
                r: '9'
            }),
            React.createElement('rect', {
                className: 'fill-color',
                fill: color,
                x: '8',
                y: '8',
                width: '2',
                height: '6',
                rx: '1'
            }),
            React.createElement('circle', { className: 'fill-color', fill: color, cx: '9', cy: '5', r: '1' })
        )
    );
};

IconInfoThin.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default IconInfoThin;
import PropTypes from 'prop-types';